import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom'; // To get the id from the URL
import { IoDocumentSharp } from 'react-icons/io5'; // PDF Icon
import { useCookies } from 'react-cookie';

function FullDetailsUsers() {
  const { id } = useParams(); // Get the user id from the URL
  const [userData, setUserData] = useState(null); // To store the fetched user data
  const [error, setError] = useState(''); // To store error messages if any
 const [cookies,setCookie, removeCookie] = useCookies(["authToken", "userName", "role", "team"]);
  // Function to map FNF Status codes to their descriptions
  const mapFNFStatus = (status) => {
    switch (status) {
      case 'C':
        return 'Complete';
      case 'I':
        return 'In Progress';
      case 'P':
        return 'Pending';
      default:
        return 'Unknown';
    }
  };

  // Helper function to check if a file is a PDF based on its extension
  const isPDF = (fileName) => {
    return fileName?.toLowerCase().endsWith('.pdf');
  };

  // Handle document deletion
  const handleDelete = async (docType, userid) => {
    try {
      const response = await fetch(` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/ExitsDocuments/${userid}/${docType}`, {
        method: 'DELETE',
      });

      if (response.ok) {
        alert(`${docType} has been deleted successfully!`);
        // After deletion, remove the document from the state to update the UI
        setUserData((prevData) => ({
          ...prevData,
          [docType]: null, // Remove the deleted document from state
        }));
      } else {
        const data = await response.json();
        alert(data.message || 'Failed to delete document');
      }
    } catch (error) {
      alert('Error deleting document');
    }
  };

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await fetch(` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/ExitCandidate/${id}`);
        const data = await response.json();
        
        if (response.ok) {
          setUserData(data); // Store the user data
        } else {
          setError(data.message || 'Failed to fetch user data');
        }
      } catch (err) {
        setError('An error occurred while fetching data');
      }
    };

    fetchUserData();
  }, [id]); // Re-fetch data when the `id` changes

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-[200px] px-4 text-center">
        <div className="bg-red-50 border border-red-200 text-red-800 px-6 py-5 rounded-2xl shadow-md w-full max-w-md">
          <div className="flex items-center space-x-2 mb-3 justify-center">
            <svg
              className="w-6 h-6 text-red-500"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v2m0 4h.01M12 19c-3.866 0-7-3.134-7-7s3.134-7 7-7 7 3.134 7 7-3.134 7-7 7z"
              />
            </svg>
            <h2 className="text-base font-semibold">Alert Message</h2>
          </div>
          <p className=" text-red-700 text-lg font-bold">{error}</p>
        </div>
      </div>
    );
  }
  

  if (!userData) {
    return <div className="loading text-center text-gray-500">Loading...</div>;
  }

  const renderDocument = (docType) => {
    const doc = userData[docType];
    if (!doc) {
      return <span className="text-red-500 text-sm">Document not uploaded</span>; // Show message if document is not uploaded
    }

    const fileUrl = ` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/ExitsEmployeeDocuments/${doc.replace("ExitsEmployeeDocuments/","")}`;

    // If it's a PDF
    if (isPDF(doc)) {
      return (
        <div className="flex flex-col items-center">
          <IoDocumentSharp className="text-red-500" size={40} />
          <a
            href={fileUrl}
            download
            className="cursor-pointer text-blue-500 underline text-sm mt-2"
          >
            Download PDF
          </a>
        </div>
      );
    }

    // If it's an image
    return (
      <div className="flex flex-col items-center">
        <img
          src={fileUrl}
          style={{ width: "80px", height: "80px" }}
          alt={`${docType}`}
        />
        <a
          href={fileUrl}
          download
          className="cursor-pointer text-blue-500 underline text-sm mt-2"
        >
          Download Image
        </a>
      </div>
    );
  };

  return (
    <div className="user-details p-8 bg-white rounded-lg shadow-lg max-w-3xl mx-auto mt-14">
      <h1 className="text-2xl font-semibold mb-6 text-center text-indigo-600 ">Full Details for {userData?.userid?.username}</h1>

      <table className="min-w-full mt-4 border-collapse table-auto">
        <thead>
          <tr className="bg-indigo-600 text-white">
            <th className="border px-6 py-2 text-base">Field</th>
            <th className="border px-6 py-2 text-base">Details</th>
            <th className="border px-6 py-2 text-base">Actions</th>
          </tr>
        </thead>
        <tbody className="font-semibold text-gray-800">
          <tr>
            <td className="border px-6 py-4 text-sm"><strong>Name</strong></td>
            <td className="border px-6 py-4 text-sm">{userData?.userid?.username}</td>
          </tr>
          <tr>
            <td className="border px-6 py-4 text-sm"><strong>Employee ID</strong></td>
            <td className="border px-6 py-4 text-sm">{userData?.userid?.EmployeeID}</td>
          </tr>
          <tr>
            <td className="border px-6 py-4 text-sm"><strong>Email</strong></td>
            <td className="border px-6 py-4 text-sm">{userData?.userid?.email}</td>
          </tr>
          <tr>
            <td className="border px-6 py-4 text-sm"><strong>FNF Status</strong></td>
            <td className="border px-6 py-4 text-sm">{mapFNFStatus(userData.FNF_Status)}</td>
          </tr>

          {/* Salary Slip */}
          <tr>
            <td className="border px-6 py-4 text-sm"><strong>Salary Slips 
(For last 3 Months)</strong></td>
            <td className="border px-6 py-4 text-sm">
              {renderDocument('Salary_Slip')}
            </td>
            
            {cookies.role !== "67f7d873fa852258bf9a2112" && (

            <td className="border px-6 py-4 text-sm">
              {userData?.Salary_Slip ? (
                
                <button
                  className="text-red-600 hover:text-red-800 font-semibold"
                  onClick={() => handleDelete('Salary_Slip', userData?.userid?._id)} 
                >
                  Delete
                </button>
              ) : null}
            </td>
            )}
          </tr>

          {/* Experience Letter */}
          <tr>
            <td className="border px-6 py-4 text-sm"><strong>Relieving Letter cum Experience Certificate</strong></td>
            <td className="border px-6 py-4 text-sm">
              {renderDocument('Experience_Letter')}
            </td>
            {cookies.role !== "67f7d873fa852258bf9a2112" && (
            <td className="border px-6 py-4 text-sm">
              {userData?.Experience_Letter ? (
                <button
                  className="text-red-600 hover:text-red-800 font-semibold"
                  onClick={() => handleDelete('Experience_Letter', userData?.userid?._id)} 
                >
                  Delete
                </button>
              ) : null}
            </td>
            )}
          </tr>

          {/* Form 16 */}
          <tr>
            <td className="border px-6 py-4 text-sm"><strong>Form 16</strong></td>
            <td className="border px-6 py-4 text-sm">
              {renderDocument('Form16')}
            </td>
            {cookies.role !== "67f7d873fa852258bf9a2112" && (
            <td className="border px-6 py-4 text-sm">
              {userData?.Form16 ? (
                <button
                  className="text-red-600 hover:text-red-800 font-semibold"
                  onClick={() => handleDelete('Form16', userData?.userid?._id)} 
                >
                  Delete
                </button>
              ) : null}
            </td>
            )}
          </tr>

          <tr>
            <td className="border px-6 py-4 text-sm"><strong>Exit Statement</strong></td>
            <td className="border px-6 py-4 text-sm">
              {renderDocument('ExitStatement')}
            </td>
            {cookies.role !== "67f7d873fa852258bf9a2112" && (
            <td className="border px-6 py-4 text-sm">
              {userData?.ExitStatement ? (
                <button
                  className="text-red-600 hover:text-red-800 font-semibold"
                  onClick={() => handleDelete('ExitStatement', userData?.userid?._id)} 
                >
                  Delete
                </button>
              ) : null}
            </td>
            )}
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default FullDetailsUsers;
